var content = require("!!../../node_modules/css-loader/dist/cjs.js??ref--7-1!../../node_modules/sass-loader/lib/loader.js??ref--7-2!./DigTable.scss");

if (typeof content === 'string') {
  content = [[module.id, content, '']];
}

var options = {}

options.insert = "head";
options.singleton = false;

var update = require("!../../node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js")(content, options);

if (content.locals) {
  module.exports = content.locals;
}
